import CensusStats from './CensusStats';
export default CensusStats;
